import React, { useState } from 'react';
import { Button, Form, Input, Select, Space, Modal } from 'antd';
import TextArea from 'antd/es/input/TextArea';
import { ApiConfig } from '../../services/ApiConfigs';
import { ApiServices } from '../../services/apiServices';

const { Option } = Select;

const layout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 16 },
};

const tailLayout = {
    wrapperCol: { offset: 8, span: 16 },
};

const MessageCmp = ({ isModalOpen, setIsModalOpen, type, selectedUser }) => {

    // type 1 = single // user 0 = all user

    const handleOk = () => {
        setIsModalOpen(false);
    };

    const handleCancel = () => {
        setIsModalOpen(false);
    };

    const [form] = Form.useForm();

    const onFinish = (values) => {
        if (selectedUser?.id) {
            values.driver_id = selectedUser?.id
        }
        values.type = type
        console.log(values);
        try {
            ApiServices('post', ApiConfig.SEND_ADMIN_MESSAGE, values).then((res) => {
                console.log(res, "SEND_ADMIN_MESSAGE response..");
                if (res.status) {
                    setIsModalOpen(false)
                } else {
                    alert(res.error)
                }
            })
        } catch (error) {
            console.log(error)
        }
    };

    const onReset = () => {
        form.resetFields();
    };

    const onFill = () => {
        form.setFieldsValue({ note: 'Hello world!', gender: 'male' });
    };

    return (
        <Modal 
            title={type ? "Send Driver Notification" : "Broadcast Driver Announcement"} 
            open={isModalOpen} 
            onCancel={handleCancel}
            footer={null}
            destroyOnHidden
            centered
            width={520}
        >
            <Form
                form={form}
                name="notification-form"
                onFinish={onFinish}
                layout="vertical"
                style={{ marginTop: 16 }}
            >
                <Form.Item 
                    name="title" 
                    label={<span style={{ fontWeight: 600 }}>Notification Title</span>} 
                    rules={[{ required: true, message: 'Please enter a notification title' }]}
                >
                    <Input placeholder="e.g. Traffic Alert / Delivery Schedule Update" size="large" />
                </Form.Item>

                <Form.Item 
                    name="body" 
                    label={<span style={{ fontWeight: 600 }}>Message Body</span>} 
                    rules={[{ required: true, message: 'Please enter message body' }]}
                >
                    <TextArea
                        placeholder="Write the notification message to broadcast to drivers..."
                        autoSize={{ minRows: 4, maxRows: 6 }}
                        size="large"
                    />
                </Form.Item>

                <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 10, marginTop: 24 }}>
                    <Button htmlType="button" onClick={onReset} size="middle">
                        Reset
                    </Button>
                    <Button onClick={handleCancel} size="middle">
                        Cancel
                    </Button>
                    <Button type="primary" htmlType="submit" size="middle" style={{ fontWeight: 600 }}>
                        Send Notification
                    </Button>
                </div>
            </Form>
        </Modal>
    );
};

export default MessageCmp;